module.exports = __webpack_public_path__ + "static/media/traffic-severe.11c51682.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traffic-severe.svg
// module id = 810
// module chunks = 0